package one.devsbox.www.ui.company.edit

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class CompanyECtx private constructor(
    val vm: CompanyEVM,
    val nav: Navigation,
    val args: ArgsId,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): CompanyECtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(CompanyEVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primaryContainer
            val colorSecondary = MaterialTheme.colorScheme.secondaryContainer
            val colorError = MaterialTheme.colorScheme.errorContainer

            return remember {
                CompanyECtx(
                    vm, nav, args, me,
                    colorPrimary, colorSecondary, colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
